import React from 'react';
import { Modal } from '@wds/modal';
import { ProgressCircle } from '@wds/progress-circle';
import { Typography } from '@wds/typography';
import { createUseStyles } from 'react-jss';
var useStyles = createUseStyles(function (_a) {
  var spacing = _a.spacing;
  return {
    progressSpinner: {
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    textWrapper: {
      margin: [spacing[2], 'auto']
    },
    wrapper: {
      padding: [spacing[6], spacing[1], spacing[5], spacing[1]],
      textAlign: 'center'
    }
  };
});
var PageLoader = function (_a) {
  var _b = _a.show,
    show = _b === void 0 ? true : _b,
    label = _a.label;
  var _c = useStyles(),
    progressSpinner = _c.progressSpinner,
    textWrapper = _c.textWrapper,
    wrapper = _c.wrapper;
  return React.createElement(Modal, {
    show: show,
    dismissible: false,
    size: "sm"
  }, React.createElement(Modal.Body, {
    padding: false
  }, React.createElement("div", {
    className: wrapper
  }, React.createElement("div", {
    className: progressSpinner
  }, React.createElement(ProgressCircle, {
    size: "md",
    continuous: true,
    valueText: "loading"
  })), React.createElement("div", {
    className: textWrapper
  }, React.createElement(Typography, {
    component: "span",
    align: "center",
    variant: "cardTitle"
  }, label !== null && label !== void 0 ? label : 'Loading')))));
};
export { PageLoader };